import { Origin } from '@kistill/client/data-access'
import {
  HeaderTableCell,
  TableItemCell,
  IconRouteButton,
} from '@kistill/client/shared/ui'
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import { format } from 'date-fns'
import { useNavigate } from 'react-router-dom'

interface OriginContentProps {
  data: Origin[] | null
}

export function RecentOrigins({ data }: OriginContentProps) {
  const navigate = useNavigate()

  const handleRowDoubleClick = (guid: string) => {
    navigate(`/uppruni/${guid}`)
  }

  return (
    <>
      <Typography component='h2' variant='h4' sx={{ mb: 1 }}>
        Upprunar
      </Typography>
      <TableContainer>
        <Table aria-label='origin table'>
          <TableHead>
            <TableRow>
              <HeaderTableCell>Númer</HeaderTableCell>
              <HeaderTableCell>Heiti</HeaderTableCell>
              <HeaderTableCell>Skráð</HeaderTableCell>
              <HeaderTableCell> </HeaderTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data &&
              data &&
              data.map((row, index) => (
                <TableRow
                  key={`origins-${index}`}
                  sx={{
                    '&:last-child td, &:last-child th': { border: 0 },
                  }}
                  onDoubleClick={() => handleRowDoubleClick(row.guid)}
                  hover={true}
                >
                  <TableItemCell>{row.originNumber}</TableItemCell>
                  <TableItemCell>{row.originJsonResponse.heiti}</TableItemCell>
                  <TableItemCell>
                    {format(
                      new Date(row.originJsonResponse.dagsetning),
                      'dd.MM.yyyy',
                    )}
                  </TableItemCell>
                  <TableItemCell sx={{ width: 0, p: 1 }}>
                    <IconRouteButton
                      to={`/uppruni/${row.guid}`}
                      tooltipText='Breyta'
                    >
                      <EditIcon fontSize='small' />
                    </IconRouteButton>
                  </TableItemCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
